<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Enrollment
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }} Enrollments</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedEnrollments" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-card-text>
              <h3>Current Enrollments:</h3>
              <div v-for="item in editedEnrollments" v-bind:key="item.enrollmentID">
                {{ item.enrollmentName }}
              </div>
            <!--<v-select
              :items="editedEnrollments"
              v-model="holder"
              item-value="name"
              label="Enrollment"
              multiple-line
              bottom
              multiple
            ></v-select> -->
            <v-select
                name="trial.trialEnrollments"
                label="Add Trial Enrollments"
                :items="enrollments"
                item-value="enrollmentId"
                item-text="enrollmentName"
                v-model="trialEnrollments"
                id="trial.trialEnrollments"
                multiple
                max-height="400"
                hint="Pick your enrollments"
                persistent-hint
              ></v-select>             
            </v-card-text>
            <v-btn depressed class="grey white--text" to="/enrollment/new">Create New Enrollment</v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      editDialog: false,
      editedEnrollments: this.trial.trialEnrollments,
      trialEnrollments: [],
      holder: []
    }
  },
  computed: {
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    loadEnrollments () {
      return this.$store.getters.loadedTrials
    }
  },
  methods: {
    onSaveChanges () {
      this.trialEnrollments = this.editedEnrollments
      this.editDialog = false
      console.log('edit page: ' + this.trialEnrollments)
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialEnrollments: this.trialEnrollments
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialEnrollmentsDialog.vue?477e5b2f